import Drawer from 'react-modern-drawer';
import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import projectServices from './projectServices';
import CurrentJobs from '../User Profile/CurrentJobs';
import cachingMechanisum from '../Common/cachingMechanisum';

export default function ProjectCalculation(projectDetails: any) {

    const [openFirst, setOpenFirst] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const toggleDrawer = () => { setIsOpen(!isOpen) }
    const [showTab, setShowTab] = useState(1);
    let [yearList, setYearList] = useState<any[]>([]);
    let [checkboxValue, setCheckboxValue] = useState<any[]>([]);
    let [period, setPeriod] = useState<any[]>([]);
    let loop = 0;
    const [calculated, setCalculated] = React.useState(false);
    let [periodSelected, SetperiodSelected] = useState<any>([]);

    useEffect(() => {
        periodSelected = cachingMechanisum.getCachingStorage("SystemPeriod");
        SetperiodSelected(periodSelected)
    }, []);

    const list = () => {
        yearList = [];

        for (var $i = 0; $i < periodSelected?.length; $i++) {
            let periodDesc = ""
            periodDesc = (periodSelected[$i].periodDesc).toString();

            if ((Number((periodDesc).slice(4, 6)) === 3) || (Number((periodDesc).slice(4, 6)) === 6) ||
                (Number((periodDesc).slice(4, 6)) === 9) || (Number((periodDesc).slice(4, 6)) === 12)) {

                yearList.push([(periodDesc).slice(0, 4), format(new Date((periodDesc).slice(4, 6)), 'MMMM'), ((periodDesc).slice(6))])
            }
        }
        setYearList(yearList);
        if (loop === 0) {

            checkboxValue = [];
            for (var $i = 0; $i < yearList.length - 20; $i++) {
                //console.log(yearList[$i][0]  + " and " + yearList[$i][1]  + " and "+ yearList[$i+2][1] +" and "+ yearList[$i+3][1])
                checkboxValue.push({ year: yearList[$i][1] + " " + yearList[$i][2] + " ," + yearList[$i][0] })
            }

        } loop = 2;

        setCheckboxValue(checkboxValue)
        console.log(checkboxValue)
    }

    const checkbox = (year: any) => {
        const { name, checked } = year.target;
        let tempcheckboxValue = [];

        console.log(name.slice(-4))

        if (name.length > 8) {
            tempcheckboxValue = checkboxValue.map(checkboxValue => (
                checkboxValue.year === name) ? { ...checkboxValue, isChecked: checked } : checkboxValue);

        } else {
            tempcheckboxValue = checkboxValue.map(checkboxValue => (
                (checkboxValue.year.slice(-4)) === name.slice(-4)) ? { ...checkboxValue, isChecked: true } : checkboxValue);
        }

        checkboxValue = tempcheckboxValue;
        setCheckboxValue(tempcheckboxValue);

        console.log(checkboxValue);
    }

    const calculationContract = () => {
        period = [];
        var data = {}
        for (var $i = 0; $i < checkboxValue.length; $i++) {
            if (checkboxValue[$i].isChecked === true) {
                // console.log(checkboxValue[$i].year)
                period.push(format(new Date(checkboxValue[$i].year), 'yyyy-MM-dd\'T\'HH:mm:ss'))
            }
        }

        setPeriod(period);

        data = {
            Period: period, ProjectCode: projectDetails.projectDetails.projectCode, allContracts: true
        }
        console.log(data)

        projectServices.calculationContract(data)
            .then((res) => {

                if (res.result === "Contract calculation initiated") {
                    setCalculated(true);
                }
                console.log(res.result)
            })
    }

    return (
        <div className="width-auto">
            <div onClick={() => setOpenFirst(true)}>
                <a className="text-center icon-btn edit pull-right btn-sm"
                    onClick={() => { toggleDrawer(); list(); }}>
                    <i className="icon-sigma-sum"></i>
                </a>
            </div>

            <Drawer open={openFirst}
                onClose={() => setOpenFirst(false)}
                direction='right'
                className='react-drawer'
                size={1200}>

                <div className='box noBorderRadius noBorder'>

                    <div className="box-header  noBorderRadius bg-blue pLarge">
                        Project Calculation
                    </div>

                    <div className="ws-12">
                        <div className="ws-3 full-height-vh" style={{ background: "#2d3a8f" }}>
                            <div className="pLarge">
                                <table className="mll mtl ">
                                    <tbody>
                                        <tr className=" pull-right ws-12" >
                                            <td className="pull-left" style={{ border: "#47529d" }}>
                                                <span className={showTab === (1) ? "mll white" : " mll active"}> 1 </span>
                                                <i className={showTab === (2) ? "purple icon-filled-circle positionRelative" : "white icon-filled-circle positionRelative p0"}></i>
                                            </td>
                                            <td style={{ border: "#47529d" }}><span className={showTab === (1) ? "pull-right white" : "active"} onClick={() => setShowTab(1)}>Calculation Period </span></td>
                                        </tr>

                                        <tr className=" pull-right ws-12" >
                                            <td className="pull-left" style={{ border: "#47529d" }}>
                                                <span className={showTab === (2) ? "mll white" : "mll active"}>2 </span>
                                                <i className={showTab === (1) ? "purple icon-filled-circle positionRelative" : "white icon-filled-circle positionRelative p0"} ></i>
                                            </td>
                                            <td style={{ border: "#47529d" }}><span className={showTab === (2) ? "pull-right white" : "active"} onClick={() => setShowTab(2)}>Calculation Summary </span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className={showTab === (1) ? 'ws-9 box' : "hide"}>
                            <div className="box-header ws-12 ">
                                <h2 className='pull-left'>Choose Calculation Period</h2>
                                <i className="icon-close pull-right pLarge" onClick={() => { setOpenFirst(false); list() }}></i>
                            </div>

                            <div className='box-content ws-12'>

                                {
                                    <div className='ws-2 pull-left'>
                                        {checkboxValue.map((post, index) => {

                                            return (
                                                <label className={(index % 4) === 0 ? 'ws-12 m0 ptl' : "hide"}>{(post.year).slice(-4)}
                                                    <input type="checkbox" name={(post.year).slice(6)}
                                                        checked={(checkboxValue[index].isChecked &&
                                                            checkboxValue[index + 1].isChecked && checkboxValue[index + 2].isChecked && checkboxValue[index + 3].isChecked) === true ? true : false}
                                                        onChange={(e: any) => { checkbox(e); }} className="m0 mr" />
                                                </label>
                                            );

                                        }

                                        )}
                                    </div>
                                }

                                <div className='ws-10 pull-right'>
                                    {checkboxValue.map((post, index) => {

                                        return (
                                            <div className={""}>

                                                <label className='ws-3 m0 ptl '>{post.year}
                                                    <input type="checkbox" name={post.year}
                                                        checked={post.isChecked}
                                                        onChange={(e: any) => { checkbox(e); }} className="m0 mr" />
                                                </label>

                                            </div>
                                        );
                                    }
                                    )}
                                </div>

                            </div>
                        </div>

                        <div className={showTab === (2) ? 'ws-9 box' : "hide"}>
                            <div className="box-header ws-12 ">
                                <h2 className='pull-left'>Summary of selection</h2>
                                <i className="icon-close pull-right pLarge" onClick={() => setOpenFirst(false)}></i>
                            </div>

                            <div className="box-content min-height400">
                                <form className="form-horizontal form-condensed">
                                    <p >Please find below the summary for your calculation criteria.</p>

                                    <div className={calculated === true ? "" : "hide"}>
                                        <div className="alert alert-info ">
                                            Calculation Initiated For : Project : {projectDetails.projectDetails.projectName}( {projectDetails.projectDetails.projectCode} )
                                        </div>

                                        <div className="centerWindow ws-4 mtl">
                                            <CurrentJobs type="calculation" />
                                            <a className="icon-btn edit ws-12 text-center mtl hide">View Job Status</a>
                                        </div>
                                    </div>

                                    <div className="alert alert-info ws-12 hide">
                                        Processing Contract Calculations For : Project : {projectDetails.projectDetails.projectName}( {projectDetails.projectDetails.projectCode} )
                                    </div>

                                    <div className={calculated === true ? "hide" : "ws-6 controls"}>
                                        <div data-ng-hide="contractCalculationProcessing">
                                            <div className="form-format ws-12">
                                                <label className="control-label text-right ws-4 pr text-bold " >Summary Type : </label>
                                                <div className="label-entries ws-8 ">Project : {projectDetails.projectDetails.projectName}( {projectDetails.projectDetails.projectCode} )</div>
                                            </div>
                                            <div className="form-format ws-12">
                                                <label className="control-label text-right ws-4 pr text-bold ">Period : </label>
                                                <div className="label-entries ws-8">
                                                    {
                                                        checkboxValue.map(post => {
                                                            return (<div className={(checkboxValue && post.isChecked === true) ? "mb" : "hide"} >{post.year}</div>);
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="ws-12">
                                        <div className="centerWindow ws-4 mtl">
                                            <a className={calculated === true ? "hide" : "icon-btn edit ws-12 text-center mtl"} onClick={calculationContract}>Initiate Calculations</a>

                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>

                        <div className={calculated === false ? "ws-9 box pm prx" : "hide"}>
                            <button className={showTab === (1) ? "icon-btn edit pull-right mr " : "hide"} onClick={() => setShowTab(2)}>Next</button>
                            <button className={showTab === (2) ? "icon-btn edit pull-right mr " : "hide"} onClick={() => setShowTab(1)}>Back</button>
                            <button className="icon-btn delete pull-none mr  hide ">Close <i className="icon-close1"></i></button>
                            <button className="icon-btn delete pull-right" onClick={() => setOpenFirst(false)}>Close</button>
                        </div>


                    </div>
                </div>
            </Drawer>
        </div>
    )
}